import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';

import {
  BROADCAST_STATUS_CARDS,
  TOTAL_STATUS_KEY,
  buildBroadcastCounts
} from './broadcastStatus';

const BroadcastReportCount = (props) => {
  const { data = [], selectedStatus = null, onSelectStatus } = props;

  const counts = buildBroadcastCounts(data);
  const isSelectable = Boolean(onSelectStatus);
  const isFiltering = Boolean(selectedStatus);

  // Total is the "show everything" card, and clicking the active card again clears it.
  const onActivate = (key) => {
    if (!isSelectable) return;
    onSelectStatus(key === TOTAL_STATUS_KEY || key === selectedStatus ? null : key);
  };

  const onKeyDown = (event, key) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onActivate(key);
  };

  return (
    <div className="report-container">
      <div className="d-flex justify-content-around align-items-center">
        {BROADCAST_STATUS_CARDS.map(({ key, title, color, icon }) => {
          const StatusIcon = Icon[icon];
          const isSelected = key === selectedStatus;
          // Total stays legible while filtering — it is the reset affordance.
          const isDimmed = isFiltering && !isSelected && key !== TOTAL_STATUS_KEY;

          return (
            <div
              key={key}
              className="px-1"
              style={{ width: `${100 / BROADCAST_STATUS_CARDS.length}%` }}>
              <Card
                className={[
                  'report-card px-2',
                  isSelectable ? 'report-card--selectable' : '',
                  isSelected ? 'is-selected' : '',
                  isDimmed ? 'is-dimmed' : ''
                ]
                  .filter(Boolean)
                  .join(' ')}
                style={{
                  '--report-card-color': color,
                  borderBottom: `2px solid ${color}`,
                  height: '70px',
                  backgroundColor: `${color}33`
                }}
                role={isSelectable ? 'button' : undefined}
                tabIndex={isSelectable ? 0 : undefined}
                aria-pressed={isSelectable ? isSelected : undefined}
                onClick={() => onActivate(key)}
                onKeyDown={(e) => onKeyDown(e, key)}>
                <div className="card-icon" style={{ backgroundColor: color }}>
                  <div className="icon mr-2 fs-5 text-white">
                    <StatusIcon size={18} />
                  </div>
                </div>
                <div className="d-flex flex-column ps-2">
                  <span className="fs-6">{title}</span>
                  <span className="fs-4">{counts[key]}</span>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};

BroadcastReportCount.propTypes = {
  data: PropTypes.array.isRequired,
  selectedStatus: PropTypes.string,
  onSelectStatus: PropTypes.func
};

export default BroadcastReportCount;
